/* Shared Arizona Rave Pirates business inquiry form and mobile navigation.
   Event subscriber/splash form remains separate and untouched. */
(function () {
  'use strict';
  const ENDPOINT = 'https://script.google.com/macros/s/AKfycbyBuAeSudAKtYOJDV1eAXXt08d5FGDfnzoYdQJk5JpYrgqyWACIhnOF5V0EJoWRt-Lf6A/exec';
  const SERVICES = ['Marketing', 'Event Production', 'DJ Services', 'Other'];
  const BUDGETS = {
    'Marketing': ['Under $1,000', '$1,000–$3,000', '$3,000+', "Let's discuss"],
    'Event Production': ['Under $2,500', '$2,500–$10,000', '$10,000+', "Let's discuss"],
    'DJ Services': ['Under $750', '$750–$1,500', '$1,500+', "Let's discuss"],
    'Other': ['Under $1,000', '$1,000–$3,000', '$3,000+', "Let's discuss"]
  };
  const menuButton = document.querySelector('.arp-menu-toggle');
  const mobileNav = document.getElementById('arp-mobile-nav');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', function () {
      const open = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      mobileNav.hidden = !open;
    });
    mobileNav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        mobileNav.hidden = true;
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Open navigation');
      }
    });
  }

  const form = document.querySelector('[data-arp-lead-form]');
  if (!form) return;
  const select = form.querySelector('[name="service"]');
  const budgetSelect = form.querySelector('[name="budget"]');
  function refreshBudgets() {
    if (!budgetSelect) return;
    const options = BUDGETS[select && select.value] || [];
    const oldValue = budgetSelect.value;
    budgetSelect.replaceChildren();
    const placeholder = new Option(options.length ? 'Select your budget' : 'Choose a service first', '');
    budgetSelect.add(placeholder);
    options.forEach(function (value) { budgetSelect.add(new Option(value, value)); });
    budgetSelect.disabled = options.length === 0;
    budgetSelect.value = options.includes(oldValue) ? oldValue : '';
  }
  if (select && budgetSelect) {
    select.addEventListener('change', refreshBudgets);
    refreshBudgets();
  }
  const submit = form.querySelector('[data-arp-submit]');
  const feedback = form.querySelector('[data-arp-feedback]');
  let sending = false;
  let pendingId = '';

  document.querySelectorAll('[data-arp-service]').forEach(function (link) {
    link.addEventListener('click', function () {
      const service = link.getAttribute('data-arp-service');
      if (SERVICES.includes(service)) { select.value = service; refreshBudgets(); }
    });
  });

  function makeId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      const b = new Uint8Array(16);
      window.crypto.getRandomValues(b);
      return Array.from(b, function (n) { return n.toString(16).padStart(2, '0'); }).join('');
    }
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 14);
  }

  function setFeedback(message, state) {
    feedback.textContent = message;
    feedback.dataset.state = state || '';
  }

  /* Apps Script ContentService POST responses cannot be read cross-origin.
     Poll a read-only status endpoint using an opaque submission ID (no PII in URL).
     If status is not verifiable, do NOT show a false success message. */
  function getStatus(id) {
    return new Promise(function (resolve, reject) {
      const cb = 'arpStatusCb_' + Math.random().toString(36).slice(2, 14);
      const script = document.createElement('script');
      let finished = false;
      const timeout = window.setTimeout(function () { finish(new Error('Status request timed out')); }, 6500);
      function finish(error, value) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timeout);
        delete window[cb];
        script.remove();
        if (error) reject(error); else resolve(value);
      }
      window[cb] = function (response) { finish(null, response); };
      script.onerror = function () { finish(new Error('Could not verify submission status')); };
      script.src = ENDPOINT + '?action=status&id=' + encodeURIComponent(id) + '&callback=' + cb + '&_=' + Date.now();
      document.head.appendChild(script);
    });
  }

  function delay(ms) { return new Promise(function (resolve) { window.setTimeout(resolve, ms); }); }
  async function waitForConfirmation(id) {
    for (let attempt = 0; attempt < 5; attempt++) {
      if (attempt > 0) await delay(1200 * attempt);
      try {
        const response = await getStatus(id);
        if (response && response.success === true && response.saved === true) return true;
      } catch (error) { /* Try again; the write might still be processing. */ }
    }
    return false;
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (sending) return;
    setFeedback('', '');
    if (!form.reportValidity()) return;

    const values = new FormData(form);
    if ((values.get('website_check') || '').trim() !== '') return; // honeypot

    const payload = {
      form_type: 'business_inquiry',
      submission_id: pendingId || makeId(),
      first_name: String(values.get('first_name') || '').trim(),
      last_name: String(values.get('last_name') || '').trim(),
      email: String(values.get('email') || '').trim(),
      phone: String(values.get('phone') || '').trim(),
      service: String(values.get('service') || ''),
      budget: String(values.get('budget') || '').trim(),
      message: String(values.get('message') || '').trim(),
      source_page: String(values.get('source_page') || window.location.pathname),
      website_check: ''
    };
    pendingId = payload.submission_id;
    sending = true;
    submit.disabled = true;
    const originalSubmitLabel = submit.textContent;
    submit.textContent = 'Sending your inquiry...';
    setFeedback('Sending your details securely. This may take a moment.', '');
    try {
      await fetch(ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      });
      const verified = await waitForConfirmation(pendingId);
      if (!verified) throw new Error('Submission could not be verified');
      form.reset();
      if (select) select.value = SERVICES.includes(form.dataset.defaultService) ? form.dataset.defaultService : '';
      refreshBudgets();
      pendingId = '';
      setFeedback("You're on our radar! Your inquiry is in, and we'll be in touch.", 'success');
    } catch (error) {
      console.error('ARP inquiry was not verified:', error);
      setFeedback("We couldn't confirm that your inquiry was saved. Please try again, or email booking@ravepirates.com. Retrying won't create a duplicate if it was saved.", 'error');
    } finally {
      sending = false;
      submit.disabled = false;
      submit.textContent = originalSubmitLabel;
    }
  });
})();
